'use client'

import { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'

import { cn } from '@/lib/utils'

type PasswordInputProps = Omit<React.ComponentPropsWithoutRef<'input'>, 'type'>

/**
 * Input de senha com botão "olhinho" para alternar visibilidade do texto.
 * Funciona tanto controlado (value/onChange) quanto não-controlado
 * (defaultValue + name, usado em `<form action={...}>`).
 */
export function PasswordInput({ className, ...props }: PasswordInputProps) {
  const [visivel, setVisivel] = useState(false)

  return (
    <div className="relative">
      <input
        {...props}
        type={visivel ? 'text' : 'password'}
        className={cn(className, 'pr-11')}
      />
      <button
        type="button"
        onClick={() => setVisivel((v) => !v)}
        aria-label="Mostrar senha"
        aria-pressed={visivel}
        className="absolute right-0 top-1/2 -translate-y-1/2 flex h-11 w-11 items-center justify-center text-muted-2 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-lg"
      >
        {visivel ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  )
}
